import { render, staticRenderFns } from "./table-data.vue?vue&type=template&id=4001cc38"
import script from "./table-data.vue?vue&type=script&lang=js"
export * from "./table-data.vue?vue&type=script&lang=js"
import style0 from "./table-data.vue?vue&type=style&index=0&id=4001cc38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports